import { enableProdMode, provideAppInitializer, inject, APP_ID, importProvidersFrom } from '@angular/core';
import { environment, provideInMemoryBackendConfig } from './environments/environment';
import { Title, provideClientHydration, withHttpTransferCacheOptions, BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrandService } from './app/common/services/brand-service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StartupService } from './app/common/services/startup.service';
import { NgxCommonModule } from 'ui-common-components-angular';
import { AdobeAnalyticsModule } from './app/adobe-analytics/adobeanalytics.module';
import { NgIdleModule } from '@ng-idle/core';
import { EventTrackerModule } from './app/event-tracker/event-tracker.module';
import { AppComponent } from './app/app.component';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, NgxCommonModule, AdobeAnalyticsModule, NgIdleModule.forRoot(), EventTrackerModule),
        Title,
        BrandService,
        provideHttpClient(withInterceptorsFromDi()),
        provideInMemoryBackendConfig(),
        provideAnimations(),
        provideAppInitializer(() => {
            const startupService = inject(StartupService);
            return startupService.load();
        }),
        {
            provide: APP_ID,
            useValue: 'p-contactus'
        },
        provideClientHydration(withHttpTransferCacheOptions({
            includeRequestsWithAuthHeaders: true
        })),
    ]
})
    .catch((err) => console.error(err));
